// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-overlay-root {
  position: absolute;
  inset: 0;
  z-index: 50;
  pointer-events: none;
}

.app-overlay-root .client-info-overlay,
.app-overlay-root .section-expanded-overlay {
  pointer-events: auto;
}

.client-info-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0;
  z-index: 50;
}

.client-info-panel {
  width: 100%;
  height: 100%;
  max-width: none;
  background: var(--surface-color);
  border-radius: 0;
  padding: 2.5rem 3rem;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.2);
  position: relative;
  color: #1f2937;
  line-height: 1.6;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.5) transparent;
}

.client-info-close-wrapper {
  position: sticky;
  top: 0;
  height: 0;
  z-index: 5;
}

.client-info-panel::-webkit-scrollbar {
  width: 9px;
}

.client-info-panel::-webkit-scrollbar-track {
  background: transparent;
}

.client-info-panel::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.75);
  border-radius: 10px;
}

.App.dark .client-info-panel,
.app-overlay-root.dark .client-info-panel {
  background: #1f2937;
  color: #f9fafb;
  scrollbar-color: rgba(75, 85, 99, 0.7) transparent;
}

.App.dark .client-info-panel::-webkit-scrollbar-thumb,
.app-overlay-root.dark .client-info-panel::-webkit-scrollbar-thumb {
  background-color: rgba(75, 85, 99, 0.9);
}

.client-info-close-btn {
  position: absolute;
  top: 0.75rem;
  left: 0;
  border: none;
  background: transparent;
  color: rgba(71, 85, 105, 0.7);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  justify-content: center;
  padding: 0.1rem 0;
  font-size: clamp(1rem, 1.2vw, 1.4rem);
  font-weight: 600;
  transition: opacity 0.2s ease;
  z-index: 5;
}

.client-info-close-btn:hover {
  opacity: 0.72;
}

.client-info-close-btn svg {
  width: 1.1em;
  height: 1.1em;
}

.App.dark .client-info-close-btn,
.app-overlay-root.dark .client-info-close-btn {
  color: rgba(226, 232, 240, 0.6);
}

.App.dark .client-info-close-btn:hover,
.app-overlay-root.dark .client-info-close-btn:hover {
  opacity: 0.72;
}

@media (max-width: 768px) {
  .App.app-overlay-root {
    display: block !important;
  }

  .app-overlay-root {
    position: static;
    inset: auto;
    z-index: auto;
  }

  .client-info-overlay {
    position: fixed;
    padding: 0;
  }

  .client-info-panel {
    max-width: 100vw;
    max-height: 100vh;
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 1rem;
  }

  .client-info-close-wrapper {
    position: sticky;
    top: 0;
    background: transparent;
    z-index: 10;
  }

  .client-info-panel--landing .client-info-close-wrapper {
    padding-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/overlays/OverlayShell.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,kDAAkD;AACpD;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".app-overlay-root {\n  position: absolute;\n  inset: 0;\n  z-index: 50;\n  pointer-events: none;\n}\n\n.app-overlay-root .client-info-overlay,\n.app-overlay-root .section-expanded-overlay {\n  pointer-events: auto;\n}\n\n.client-info-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.65);\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  padding: 0;\n  z-index: 50;\n}\n\n.client-info-panel {\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  background: var(--surface-color);\n  border-radius: 0;\n  padding: 2.5rem 3rem;\n  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.2);\n  position: relative;\n  color: #1f2937;\n  line-height: 1.6;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.5) transparent;\n}\n\n.client-info-close-wrapper {\n  position: sticky;\n  top: 0;\n  height: 0;\n  z-index: 5;\n}\n\n.client-info-panel::-webkit-scrollbar {\n  width: 9px;\n}\n\n.client-info-panel::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.client-info-panel::-webkit-scrollbar-thumb {\n  background-color: rgba(148, 163, 184, 0.75);\n  border-radius: 10px;\n}\n\n.App.dark .client-info-panel,\n.app-overlay-root.dark .client-info-panel {\n  background: #1f2937;\n  color: #f9fafb;\n  scrollbar-color: rgba(75, 85, 99, 0.7) transparent;\n}\n\n.App.dark .client-info-panel::-webkit-scrollbar-thumb,\n.app-overlay-root.dark .client-info-panel::-webkit-scrollbar-thumb {\n  background-color: rgba(75, 85, 99, 0.9);\n}\n\n.client-info-close-btn {\n  position: absolute;\n  top: 0.75rem;\n  left: 0;\n  border: none;\n  background: transparent;\n  color: rgba(71, 85, 105, 0.7);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  justify-content: center;\n  padding: 0.1rem 0;\n  font-size: clamp(1rem, 1.2vw, 1.4rem);\n  font-weight: 600;\n  transition: opacity 0.2s ease;\n  z-index: 5;\n}\n\n.client-info-close-btn:hover {\n  opacity: 0.72;\n}\n\n.client-info-close-btn svg {\n  width: 1.1em;\n  height: 1.1em;\n}\n\n.App.dark .client-info-close-btn,\n.app-overlay-root.dark .client-info-close-btn {\n  color: rgba(226, 232, 240, 0.6);\n}\n\n.App.dark .client-info-close-btn:hover,\n.app-overlay-root.dark .client-info-close-btn:hover {\n  opacity: 0.72;\n}\n\n@media (max-width: 768px) {\n  .App.app-overlay-root {\n    display: block !important;\n  }\n\n  .app-overlay-root {\n    position: static;\n    inset: auto;\n    z-index: auto;\n  }\n\n  .client-info-overlay {\n    position: fixed;\n    padding: 0;\n  }\n\n  .client-info-panel {\n    max-width: 100vw;\n    max-height: 100vh;\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n    padding: 1rem;\n  }\n\n  .client-info-close-wrapper {\n    position: sticky;\n    top: 0;\n    background: transparent;\n    z-index: 10;\n  }\n\n  .client-info-panel--landing .client-info-close-wrapper {\n    padding-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
